import { inject, InjectionToken, type Signal } from '@angular/core';

import type { BlockContext } from '@front-platform/content-builder';

import { BlockConfigContextService } from './block-config-context.service';

export const BLOCK_CONFIG_CONTEXT = new InjectionToken<Signal<BlockContext>>(
  'BLOCK_CONFIG_CONTEXT',
  {
    providedIn: 'root',
    factory: () => inject(BlockConfigContextService).context,
  },
);
